import * as z from 'zod/v4';

const MATCH_STATE_VARIANTS = {
  NotEntered: 0,
  Entered: 1,
  Final: 2,
  Verified: 3,
} as const;

const matchStateIdEnum = z.enum(MATCH_STATE_VARIANTS);

type MatchStateId = z.infer<typeof matchStateIdEnum>;

export type MatchStateClient = 'NotStarted' | 'Live' | 'Finished';
const getClientMatchState = (matchStateId: MatchStateId): MatchStateClient => {
  if (matchStateId < MATCH_STATE_VARIANTS.Entered) {
    return 'NotStarted';
  }

  if (matchStateId < MATCH_STATE_VARIANTS.Verified) {
    return 'Live';
  }

  return 'Finished';
};

export const matchStateSchema = matchStateIdEnum.transform((matchStateId) => {
  const matchStateClient = getClientMatchState(matchStateId);
  return {
    client: matchStateClient,
  };
});
